/* eslint-disable @typescript-eslint/typedef */
/* istanbul ignore file */

export const ErrorTypes = [
  'required',
  'minlength',
  'maxlength',
  'pattern',
  'email',
  'passwordRepeat',
  'emailRepeat',
  'postalCode',
  'minDate',
  'maxDate',
  'nameTaken',
  'select',
  'file',
  'fileMaxSize',
  'fileType',
  'fileName',
  'fileMinCount',
  'date',
  'dateFilter',
  'matStartDateInvalid',
  'matEndDateInvalid',
  'matDatepickerParse',
  'unknown',
  'custom',
] as const;

export const ErrorMessageTokens = [
  '@label',
  '@minLength',
  '@maxLength',
  '@minDate',
  '@maxDate',
  '@fileMaxSize',
  '@fileType',
  '@minCount',
] as const;

export type ErrorType = typeof ErrorTypes[number];
export type ErrorMessageTokenType = typeof ErrorMessageTokens[number];

export type ErrorMessagesModel = Record<ErrorType, string>;

export const ErrorMessages = {
  required: '@label ist erforderlich',
  minlength: '@label muss mindestens @minLength Zeichen lang sein',
  maxlength: '@label darf maximal @maxLength Zeichen lang sein',
  pattern: '@label ist nicht valide',
  email: 'Geben Sie bitte eine valide E-Mail Adresse ein',
  passwordRepeat: 'Passwörter stimmen nicht überein',
  emailRepeat: 'E-Mail-Adressen stimmen nicht überein',
  postalCode: 'Geben Sie bitte eine valide Postleitzahl ein',
  minDate: '@label muss größer oder gleich @minDate sein',
  maxDate: '@label muss kleiner oder gleich @maxDate sein',
  nameTaken: 'Der Name ist schon vergeben',
  select: 'Die Auswahl ist nicht gültig',
  file: 'Die Datei konnte nicht hochgeladen werden. Bitte überprüfen Sie die Dateigröße und das Format.',
  fileMaxSize: 'Die Datei ist zu groß. Die maximal zulässige Größe beträgt @fileMaxSize MB.',
  fileType: 'Der Dateityp wird nicht unterstützt. Bitte wählen Sie eine gültige Datei (z.B. @fileType).',
  fileName: 'Der Dateiname enthält ungültige Zeichen. Erlaubt sind Buchstaben, Ziffern, Leerzeichen sowie . - _ + ( ).',
  fileMinCount: 'Bitte laden Sie mindestens @minCount Datei(en) hoch.',
  date: '@label muss ein gültiges Datum sein',
  dateFilter: 'Das ausgewählte Datum entspricht keinem gültigen Datum',
  matEndDateInvalid: 'Das Startdatum muss vor dem Enddatum liegen',
  matStartDateInvalid: 'Das Startdatum muss vor dem Enddatum liegen',
  matDatepickerParse: 'Der eingetragene Wert entspricht keinem gültigen Datum.',
  unknown: 'Es ist ein unbekannter Fehler aufgetreten',
  custom: '',
} as const satisfies ErrorMessagesModel;

export const ErrorMessageTokenPattern: RegExp = new RegExp(
  `(${ErrorMessageTokens.join('|')})`,
  'g',
);

export type ErrorMessage = typeof ErrorMessages[ErrorType];
export type ErrorMessageTokenReplacements = Partial<Record<ErrorMessageTokenType, string>>;

export const formatErrorMessage = (message: ErrorMessage, replacements: ErrorMessageTokenReplacements): string => {
  return message.replace(
    ErrorMessageTokenPattern,
    token => replacements[token as ErrorMessageTokenType] ?? token,
  );
};
